import { useCallback } from 'react';
import { useSearchParams } from 'react-router';

/**
 * Bewaart zoekterm, filters en positie van een lijst in het adres, zodat een lijst te delen is en de knop
 * terug werkt.
 * @param limiet De paginagrootte.
 * @returns De huidige waarden en functies om ze te wijzigen.
 */
export function useZoekparameters(limiet = 25) {
  const [params, setParams] = useSearchParams();
  const zoek = params.get('zoek') ?? '';
  const offset = Math.max(0, Number(params.get('offset') ?? 0) || 0);

  const zet = useCallback(
    (wijzigingen: Record<string, string | undefined>, behoudOffset = false) => {
      setParams(
        (huidig) => {
          const volgende = new URLSearchParams(huidig);
          for (const [naam, waarde] of Object.entries(wijzigingen)) {
            if (waarde) {
              volgende.set(naam, waarde);
            } else {
              volgende.delete(naam);
            }
          }
          if (!behoudOffset) {
            volgende.delete('offset');
          }
          return volgende;
        },
        { replace: true },
      );
    },
    [setParams],
  );

  const zetOffset = useCallback((nieuw: number) => zet({ offset: nieuw > 0 ? String(nieuw) : undefined }, true), [zet]);
  const krijg = useCallback((naam: string) => params.get(naam) ?? '', [params]);

  return { zoek, offset, limiet, krijg, zet, zetOffset };
}
